<template>
  <div class="content-wrapper">
    <div class="mt-5 mb-4"></div>
    <div class="content">
      <div class="container-fluid">
        <div class="row">
          <h3>Hola</h3>
        </div>
      </div>
    </div>
  </div>
</template>